<ng-container *ngIf="form">
  <ng-container *ngFor="let question of questions">
    <app-dynamic-form-question
      [form]="form"
      [question]="question"
      [externalData]="externalData"
      (showLabFinderModal)="showLabFinderModal.emit()"
    ></app-dynamic-form-question>
  </ng-container>
</ng-container>
